import { sectionRenderer } from '@theme/section-renderer';

const errors = {
  cutOff: {
    shipping: "Shipping arrival is not available on this day. Please choose another day.",
    local: "Pickup is not available on this day. Please choose another day.",
    delivery: "Delivery is not available on this day. Please choose another day."
  }
}

// @ts-nocheck
export default class DeliverySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.abortController = new AbortController();
    if(this.querySelector('.delivery-selector__form')) {
      this.loadConfig();
    }
  }

  disconnectedCallback() {
    this.datepicker?.destroy();
    this.locationSlimSelect?.destroy();
    this.timeSlimSelect?.destroy();

    if(this.abortController) {
      this.abortController.abort();
    }

    if(this.submitAbortController) {
      this.submitAbortController.abort();
    }
  }

  loadConfig() {
    this.applyDeliveryType = this.debounceApplyDeliveryType();
    this.domElements = {
      form: this.querySelector('.delivery-selector__form'),
      location: this.querySelector('.js-location-container'),
      time: this.querySelector('.js-time-container'),
      zip: this.querySelector('.js-zip-container'),
      scrollToListButton: document.querySelector('.js-scroll-to-results-list'),
      results: document.querySelector('results-list') || document.querySelector('.flavors-list__container'),
      errors: this.querySelectorAll('.delivery-inputs__error')
    }

    this.bethesdaZipList = (document.querySelector('[data-bethesda]').getAttribute('data-bethesda') || '').split(',');
    this.georgetownZipList = (document.querySelector('[data-georgetown]').getAttribute('data-georgetown') || '').split(',');

    //Delivery seletor view - based on page user has visited
    this.selectorType = this.domElements.form['selector-view'].value;

    //Same delivery, different page
    this.formState = {
      cartType: this.domElements.form['selector-view'].value,
      date: this.domElements.form['date'].value,
      zip: this.domElements.form['zip'].value,
    }

    if(this.selectorType === "local") {
      this.formState.localDeliveryType = this.domElements.form['delivery-type'].value;
      this.formState.location = this.domElements.form['location'].value;
      this.formState.time = this.domElements.form['time'].dataset.selectedTime;
    }

    const changeView = localStorage.getItem('changeview');
    if(changeView) {
      const [date, zip] = changeView.split('|');
      this.domElements.form['date'].value = this.formState.date = date;
      this.domElements.form['zip'].value = this.formState.zip = zip;
      localStorage.removeItem('changeview');
    }

    this.formValid = false;
    this.isZipValid = false;
    this.isZipLocal = null;

    this.initSelects();
    this.restoreDataFromState();
    this.validateSelection();
    this.initDatePicker();
    this.initTimeSelect();
    this.setOutOfStock();
    this.updateFormVisibility();
    this.generateTimeOptions();
    this.initScrollToListButton();
    this.triggerFilters();
    this.toggleSectionsVisibility();
    this.updateDozenNoteVisibility();
    this.registerEventListeners();
    if(changeView) {
      this.applyDeliveryType();
    }
  }

  registerEventListeners() {
    if (this.domElements.form['location']) {
      this.domElements.form['location'].addEventListener('change', (e) => this.saveLocation(e), { signal: this.abortController.signal });
      this.domElements.form['time'].addEventListener('change', (e) => this.saveTime(e), { signal: this.abortController.signal });
      Array.from(this.domElements.form['delivery-type']).forEach((item) => item.addEventListener('change', () => this.saveDeliveryType(), { signal: this.abortController.signal }));
    }

    this.domElements.form['date'].addEventListener('change', () => this.saveDate(), { signal: this.abortController.signal });
    if(this.domElements.form['change-view']) {
      this.domElements.form['change-view'].addEventListener('click', () => this.changeView(), { signal: this.abortController.signal });
    }

    this.domElements.form['zip'].addEventListener('input', (e) => {
      this.formState.zip = e.target.value;
    }, { signal: this.abortController.signal });

    this.domElements.form.addEventListener('change', (e) => {
      onZiporDateChange(e)
    }, { signal: this.abortController.signal });

    this.domElements.form.addEventListener('keyup', (e) => {
      onZiporDateChange(e)
    }, { signal: this.abortController.signal });

    let onZiporDateChange = (e) => {
      this.updateFormVisibility();

      if(e.target.name !== 'time') {
        this.generateTimeOptions();
      }

      this.validateSelection();
      this.toggleSectionsVisibility();
      this.checkVariantsAvailability();
      this.applyDeliveryType();
    };
  }

  updateFormVisibility() {
    if(this.selectorType === "local") {
      // Hide show additional blocks
      if (this.formState.localDeliveryType === 'delivery') {
        this.domElements.location.classList.add('_hidden');
        this.domElements.time.classList.remove('_hidden');
        this.domElements.zip.classList.remove('_hidden');
      } else {
        this.domElements.location.classList.remove('_hidden');
        this.domElements.time.classList.remove('_hidden');
        this.domElements.zip.classList.add('_hidden');
      }

      // Enable disable location select
      if(this.formState.localDeliveryType === "delivery") {
        this.domElements.form['location'].disabled = true;
        this.locationSlimSelect.disable();

        const inGeorgetown = this.georgetownZipList.includes(this.formState.zip);
        const inBethesda = this.bethesdaZipList.includes(this.formState.zip);

        if (inGeorgetown) {
          this.setLocation('georgetown');
        } else if (inBethesda) {
          this.setLocation('bethesda');
        }
      } else {
        this.domElements.form['location'].disabled = false;
        this.locationSlimSelect.enable();
      }
    }
  }

  changeView() {
    let link = "/pages/"
    if(this.selectorType === "local") {
      link += "ship-nationwide"
    } else {
      link += "local-orders"
    }

    localStorage.setItem('changeview', this.formState.date + "|" + this.formState.zip)
    window.location.href = link;
  }

  setLoading() {
    this.pdp = document.querySelector('.product-information__grid');
    if(this.pdp) {
      this.pdp.classList.add('_loading');
    }

    this.grid = document.querySelector('.product-grid-container');
    if(this.grid) {
      this.grid.classList.add('_loading');
    }

    this.flavorsList = document.getElementById('flavors-container');
    if(this.flavorsList) {
      this.flavorsList.classList.add('_loading');
    }
  }

  removeLoading() {
    if(this.pdp) {
      const closestSection = this.pdp.closest('.shopify-section');
      if(closestSection) {
        return sectionRenderer.renderSection(closestSection.id.replace('shopify-section-', ''), { cache: false }).then(() => {
          this.pdp.classList.remove('_loading');
          this.disconnectedCallback();
          this.connectedCallback();
        });
      }
    }
    return Promise.resolve();
  }

  debounceApplyDeliveryType() {
    let timer = null;

    return () => {
      if(timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        this.applyDeliveryTypeAction();
      }, 200);
    }
  }

  async applyDeliveryTypeAction() {
    if(this.submitAbortController) {
      this.submitAbortController.abort();
    }

    this.submitAbortController = new AbortController();

    if(!this.formValid) {
      // Still update dozen note visibility even if form is not valid
      this.updateDozenNoteVisibility();
      return;
    }

    this.setLoading();

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          date: this.formState.date,
          zip: this.formState.zip,
          localDeliveryType: this.formState.localDeliveryType,
          location: this.formState.location,
          deliveryTime: this.formState.time,
          type: this.selectorType,
          currentDeliveryDate: this.createSelectedDayMonthString(),
        }
      }),
      signal: this.submitAbortController.signal
    })
    .then((data) => data.json())
    .then((result) => {
      if(!result.token) {
        return;
      }

      //main settings
      localStorage.setItem('delivery-ship-type', this.selectorType);
      localStorage.setItem('delivery-date', this.formState.date);
      localStorage.setItem('delivery-zip', this.formState.zip);

      //additional local settings
      if(this.selectorType === "local") {
        localStorage.setItem('delivery-type', this.formState.localDeliveryType);
        localStorage.setItem('delivery-location', this.formState.location);
        localStorage.setItem('delivery-time', this.formState.time);
      }

      this.triggerFilters();
      this.setOutOfStock();
      document.dispatchEvent(new CustomEvent('delivery-changed'));
      
      //Re-render header cart-drawer to update You may also like section
      const headerRenderPromise = sectionRenderer.renderSection(
        document.querySelector('header').id.replace('shopify-section-', ''), 
        { cache: false }
      );

      // Wait for removeLoading to complete (which may include section rendering)
      const removeLoadingPromise = this.removeLoading();
      
      // Wait for all renders to complete before updating dozen notes
      Promise.all([headerRenderPromise, removeLoadingPromise]).then(() => {
        this.updateDozenNoteVisibility();
      });
    })
    .catch(error => {
      if (error.name === 'AbortError') return;
      console.error('Error loading sections:', error)
    });
  }

  createSelectedDayMonthString() {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const date = new Date(this.formState.date);
    const day = days[date.getDay()];
    const month = months[date.getMonth()];

    return `${day}|${month}`;
  }

  async triggerFilters() {
    if (!this.filtersForm) {
      if (!customElements.get('facets-form-component')) {
        await customElements.whenDefined('facets-form-component');
      }

      const filters = document.querySelector('facets-form-component');
      if (filters) {
        this.filtersForm = filters;
      }
    }

    if (this.filtersForm && typeof this.filtersForm.updateFilters === 'function') {
      this.filtersForm.updateFilters();
    }
  }

  initScrollToListButton() {
    if (this.domElements.scrollToListButton) {
      this.domElements.scrollToListButton.addEventListener('click', () => {
        if (this.domElements.results) {
          this.domElements.results.scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
          });
        }
      }, { signal: this.abortController.signal });
    }
  }

  dayjsToJsDate(date) {
    return new Date(
      date.year(),
      date.month(),
      date.date(),
      date.hour(),
      date.minute(),
      date.second()
    );
  }

  initDatePicker() {
    // Get current date in EST timezone
    const nowEST = window.dayjs().tz('America/New_York');
    // Use dayjs format to create date string and parse it
    let minDate = this.dayjsToJsDate(nowEST);
    if(this.selectorType === 'nationwide'){
      const tomorrowEST = nowEST.add(1, 'day');
      minDate = this.dayjsToJsDate(tomorrowEST);
    }

    // Set max date to 30 days from now in EST
    const maxDateEST = nowEST.add(30, 'day');
    let maxDate = this.dayjsToJsDate(maxDateEST);

    this.datepicker = new AirDatepicker(this.domElements.form['date'], {
      minDate: minDate,
      maxDate: maxDate,
      dateFormat: 'dd MMMM yyyy',
      autoClose: true,
      onSelect: () => {
        this.saveDate();
        this.domElements.form['date'].dispatchEvent(new Event('change', { bubbles: true }));
      },
      locale: {
        days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        today: "Today",
        clear: "Clear",
        firstDay: 0
      },
    });
  }

  updateDatePickerMinDate() {
    if (!this.datepicker) return;
    
    // Save current selected date before update
    const currentSelectedDate = this.datepicker.selectedDates[0];
    
    // Get current date in EST timezone
    const nowEST = window.dayjs().tz('America/New_York');
    
    // Use dayjs format to create date string and parse it
    let minDate = this.dayjsToJsDate(nowEST);
    if(this.selectorType === 'nationwide'){
      const tomorrowEST = nowEST.add(1, 'day');
      minDate = this.dayjsToJsDate(tomorrowEST);
    }
    
    // Set max date to 30 days from now in EST
    const maxDateEST = nowEST.add(30, 'day');
    let maxDate = this.dayjsToJsDate(maxDateEST);
    
    this.datepicker.update({
      minDate: minDate,
      maxDate: maxDate
    });
    
    // Handle date selection after update
    if (this.selectorType === 'nationwide') {
      
      // If no date selected, try to restore from localStorage or set tomorrow
      if (!currentSelectedDate) {
        const savedDate = localStorage.getItem('delivery-date');
        if (savedDate) {
          const parsedDate = new Date(savedDate);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          parsedDate.setHours(0, 0, 0, 0);
          
          if (parsedDate.getTime() > today.getTime()) {
            this.datepicker.selectDate(parsedDate);
          } else {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.datepicker.selectDate(tomorrow);
            this.saveDate();
          }
        } else {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          this.datepicker.selectDate(tomorrow);
          this.saveDate();
        }
      } else {
        // Date is selected in datepicker
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        const selected = new Date(currentSelectedDate);
        selected.setHours(0, 0, 0, 0);
        
        if (selected.getTime() <= today.getTime()) {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          this.datepicker.selectDate(tomorrow);
          this.saveDate();
        } else {
          this.datepicker.selectDate(currentSelectedDate);
        }
      }
    } else if (this.selectorType === 'local') {
      
      // For local, restore date if not selected
      if (!currentSelectedDate) {
        const savedDate = localStorage.getItem('delivery-date');
        if (savedDate) {
          this.datepicker.selectDate(new Date(savedDate));
        }
      } else {
        this.datepicker.selectDate(currentSelectedDate);
      }
    }
  }

  initSelects() {
    this.locationSlimSelect = new SlimSelect({
      select: '.js-location',
      settings: {
        showSearch: false,
      }
    })
  }

  restoreDataFromState() {
    if (this.formState.date) {
      const savedDate = new Date(this.formState.date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      savedDate.setHours(0, 0, 0, 0);

      if (this.selectorType === 'nationwide') {
        if (savedDate.getTime() > today.getTime()) {
          this.domElements.form['date'].value = this.formState.date;
        } else {
          // Set to tomorrow if saved date is today or past
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          const tomorrowStr = tomorrow.toLocaleDateString('en-GB', { 
            day: 'numeric', 
            month: 'long', 
            year: 'numeric' 
          });
          this.domElements.form['date'].value = tomorrowStr;
          localStorage.setItem('delivery-date', tomorrowStr);
          this.formState.date = tomorrowStr;
        }
      } else {
        if (savedDate >= today) {
          this.domElements.form['date'].value = this.formState.date;
        } else {
          this.domElements.form['date'].value = "";
        }
      }
    }

    if (this.formState.zip) {
      this.domElements.form['zip'].value = this.formState.zip;
    }

    if(this.selectorType === "local") {
      this.domElements.form['location'].value = this.formState.location;
      this.domElements.form['time'].value = this.formState.time;
    }
  }

  saveDate() {
    this.formState.date = this.domElements.form['date'].value;
    this.toggleFormErrors(false, 'cut-off');
  }

  saveDeliveryType() {
    const previousType = this.formState.localDeliveryType;
    this.formState.localDeliveryType = this.domElements.form['delivery-type'].value;

    if (previousType !== this.formState.localDeliveryType && !this.formState.location) {
      this.formState.time = '';
    }
  }

  checkCutoffTime(type) {
    // Common date formatting for both local and nationwide
    const selectedDate = window.dayjs(this.formState.date);
    const selectedDateFormatted = selectedDate.format('YYYY-MM-DD');
    const dayOfWeek = selectedDate.format('dddd');
    const todayEST = window.dayjs().tz('America/New_York');
    const todayFormatted = todayEST.format('YYYY-MM-DD');
    const todayDayOfWeek = todayEST.format('dddd');
    const isToday = selectedDateFormatted === todayFormatted;
    
    // Calculate tomorrow
    const tomorrowEST = todayEST.add(1, 'day');
    const tomorrowFormatted = tomorrowEST.format('YYYY-MM-DD');
    const isTomorrow = selectedDateFormatted === tomorrowFormatted;
    
    if (type === 'local') {
      const unavailableDates = window.locationData[this.formState.location].unavailable_dates;
      const unavailableDays = window.locationData[this.formState.location].unavailable_days;
      const isSameDayEnabled = window.locationData[this.formState.location].same_day_delivery_pickup;
      const cutoffTimes = window.locationData[this.formState.location].cutoff_times;

      // Check unavailable dates
      if(unavailableDates.includes(selectedDateFormatted)) {
        this.formValid = false;
        this.setAttribute('data-valid', this.formValid);
        this.toggleFormErrors(true, 'cut-off');
        return;
      }

      // Check unavailable days
      if(unavailableDays.includes(dayOfWeek)) {
        this.formValid = false;
        this.setAttribute('data-valid', this.formValid);
        this.toggleFormErrors(true, 'cut-off');
        return;
      }

      // Check cutoff logic
      const todayCutoffTime = cutoffTimes?.[todayDayOfWeek];
      let isAfterCutoff = false;
      
      if (todayCutoffTime && typeof todayCutoffTime === 'string') {
        const [cutoffHours, cutoffMinutes] = todayCutoffTime.split('.').map(Number);
        if (!isNaN(cutoffHours) && !isNaN(cutoffMinutes)) {
          const cutoffDateTime = todayEST.hour(cutoffHours).minute(cutoffMinutes).second(0);
          isAfterCutoff = todayEST.isAfter(cutoffDateTime) || todayEST.isSame(cutoffDateTime);
        }
      }

      if(!isSameDayEnabled) {
        // Same day disabled: cannot order for today
        if(isToday) {
          this.formValid = false;
          this.setAttribute('data-valid', this.formValid);
          this.toggleFormErrors(true, 'cut-off');
          return;
        }
        
        // For tomorrow: check if after cutoff
        if(isTomorrow && isAfterCutoff) {
          this.formValid = false;
          this.setAttribute('data-valid', this.formValid);
          this.toggleFormErrors(true, 'cut-off');
          return;
        }
      } else {
        // Same day enabled: check cutoff for today
        if(isToday && isAfterCutoff) {
          this.formValid = false;
          this.setAttribute('data-valid', this.formValid);
          this.toggleFormErrors(true, 'cut-off');
          return;
        }
      }
    } else if (type === 'nationwide') {
      const unavailableDates = window.locationData.nationwide["unavailable_dates"];
      const unavailableDays = window.locationData.nationwide["unavailable_days"];
      const isSameDayEnabled = window.locationData.nationwide["same_day_delivery_pickup"];
      const cutoffTimes = window.locationData.nationwide["cutoff_times"];

      // Check unavailable dates
      if (unavailableDates.includes(selectedDateFormatted)) {
        this.toggleFormErrors(true, 'cut-off');
        this.formValid = false;
        this.setAttribute('data-valid', this.formValid);
        return;
      }

      // Check unavailable days
      if(unavailableDays.includes(dayOfWeek)) {
        this.toggleFormErrors(true, 'cut-off');
        this.formValid = false;
        this.setAttribute('data-valid', this.formValid);
        return;
      }

      // Check cutoff logic
      const todayCutoffTime = cutoffTimes?.[todayDayOfWeek];
      let isAfterCutoff = false;
      
      if (todayCutoffTime && typeof todayCutoffTime === 'string') {
        const [cutoffHours, cutoffMinutes] = todayCutoffTime.split('.').map(Number);
        if (!isNaN(cutoffHours) && !isNaN(cutoffMinutes)) {
          const cutoffDateTime = todayEST.hour(cutoffHours).minute(cutoffMinutes).second(0);
          isAfterCutoff = todayEST.isAfter(cutoffDateTime) || todayEST.isSame(cutoffDateTime);
        }
      }

      if(!isSameDayEnabled) {
        // Same day disabled: cannot order for today
        if(isToday) {
          this.toggleFormErrors(true, 'cut-off');
          this.formValid = false;
          this.setAttribute('data-valid', this.formValid);
          return;
        }
        
        // For tomorrow: check if after cutoff
        if(isTomorrow && isAfterCutoff) {
          this.toggleFormErrors(true, 'cut-off');
          this.formValid = false;
          this.setAttribute('data-valid', this.formValid);
          return;
        }
      } else {
        // Same day enabled: check cutoff for today
        if(isToday && isAfterCutoff) {
          this.toggleFormErrors(true, 'cut-off');
          this.formValid = false;
          this.setAttribute('data-valid', this.formValid);
          return;
        }
      }
    }
  }

  saveLocation(e) {
    if(this.formState.location === this.domElements.form['location'].value.trim()) {
      e.stopPropagation();
      return;
    }
    this.formState.location = this.domElements.form['location'].value.trim();
  }

  saveTime(e) {
    if(this.formState.time === this.domElements.form['time'].value) {
      e.stopPropagation();
      return;
    }
    this.formState.time = this.domElements.form['time'].value;
  }

  toggleFormErrors(isVisible, type) {
    this.domElements.errors.forEach(errorItem => {
      if(type && type !== errorItem.dataset.errorType) {
        return;
      }

      if(type === "cut-off") {
        if(this.selectorType === "nationwide") {
          errorItem.innerHTML = errors.cutOff.shipping;
        } else {
          if(this.formState.localDeliveryType === "pickup") {
            errorItem.innerHTML = errors.cutOff.local;
          } else {
            errorItem.innerHTML = errors.cutOff.delivery;
          }
        }
      }

      errorItem.classList.toggle('_hidden', !isVisible)
    });
  }

  validateSelection() {
    this.formValid = true;
    this.setAttribute('data-valid', this.formValid);
    this.toggleFormErrors(false);
    this.validateZip();

    if(!this.formState.zip.trim() && this.selectorType === "local" && this.formState.localDeliveryType === "delivery") {
      this.formValid = false;
      this.setAttribute('data-valid', this.formValid);
    }

    if(!this.isZipValid) {
      this.formValid = false;
      this.setAttribute('data-valid', this.formValid);
    }

    if(!this.formState.date){
      this.formValid = false;
      this.setAttribute('data-valid', this.formValid);
    }

    if(this.selectorType === "local") {
      if(!this.formState.localDeliveryType) {
        this.formValid = false;
        this.setAttribute('data-valid', this.formValid);
      }

      if(!this.formState.location){
        this.formValid = false;
        this.setAttribute('data-valid', this.formValid);
      }

      if(!this.formState.time){
        this.formValid = false;
        this.setAttribute('data-valid', this.formValid);
      }
    }

    if(this.selectorType === "local" && this.formState.location && this.formState.date) {
      this.checkCutoffTime('local');
    }

    if (this.selectorType === 'nationwide' && this.formState.date) {
      this.checkCutoffTime('nationwide');
    }

    if(!this.formValid) {
      if(!this.isZipValid && this.selectorType === "local" || !this.isZipValid && this.formState.zip.trim() && this.selectorType === "nationwide") {
        this.toggleFormErrors(true, 'delivery-type');
      }
    }
  }

  getZipType() {
    const zip = this.domElements.form['zip'].value.trim();
    if(this.bethesdaZipList.includes(zip) || this.georgetownZipList.includes(zip) || !zip) {
      return "local";
    }

    return "nationwide"
  }

  validateZip() {
    const zip = this.domElements.form['zip'].value.trim();
    const zipType = this.getZipType();

    this.isZipValid = true;
    this.isZipLocal = false;

    if(this.selectorType === "nationwide") {
      if(!zip) {
        this.isZipValid = false;
        return;
      }

      if (!/^\d{5}$/.test(zip)) {
        this.isZipValid = false;
        return;
      }

      if(zipType === "local") {
        this.isZipValid = false;
        return;
      }
    }

    if (this.selectorType === 'local') {
      if(this.formState.localDeliveryType === "pickup") {
        //do not validate zip for pickup
        return;
      }

      if(zipType === "nationwide") {
        this.isZipValid = false;
        return;
      }

      this.isZipLocal = true;
    }
  }

  setLocation(locationValue) {
    if (this.domElements.form['location']) {
      this.domElements.form['location'].value = locationValue;
      this.formState.location = locationValue;
    }
  }

  toggleSectionsVisibility() {
    const sections = document.querySelectorAll('.shopify-section');
    
    if (this.formValid) {
      sections.forEach(section => {
        const buttons = section.querySelectorAll('.button, button, [role="button"]');
        const messages = section.querySelectorAll('.image-text-grid__inactive-message');
        buttons.forEach(button => {
          if(button.classList.contains('js-add-bundle')
            || button.classList.contains('button--js-disabled')
            || button.classList.contains('product-card__button-sold-out')
            || button.name === "change-view"
          ) return;
          button.classList.remove('button-disabled');
          button.disabled = false;
          button.style.pointerEvents = '';
          messages.forEach(message => message.classList.remove('is-active'));
        });
      });
    } else {
      sections.forEach(section => {
        if (!section.classList.contains('delivery-selector-section') && !section.classList.contains('header-section') && !section.classList.contains('shopify-section-group-footer-group')) {
          const buttons = section.querySelectorAll('.button, button, [role="button"]');
          const messages = section.querySelectorAll('.image-text-grid__inactive-message');
          
          buttons.forEach(button => {
            if(button.classList.contains('js-add-bundle') 
              || button.classList.contains('button--js-disabled') 
              || button.classList.contains('show-more__btn') 
              || button.classList.contains('clear-filter')
              || button.classList.contains('product-card__detail-link--ways')
              || button.classList.contains('js-details')
              || button.classList.contains('js-scroll-to-results-list')
              || button.name === "change-view"
            ) return;
            const workshopInput = button.closest('.product-form-buttons')?.querySelector('[name="quantity"][data-workshop="true"]') || button.closest('.shopify-section')?.querySelector('[name="quantity"][data-workshop="true"]');
            if (workshopInput) return;
            button.classList.add('button-disabled');
            button.disabled = true;
            button.style.pointerEvents = 'none';
            messages.forEach(message => message.classList.add('is-active'));
          });
        }
      });
    }

    this.setOutOfStock();
  }

  timeToMinutes (timeStr) {
    const [hours, minutes] = timeStr.split('.').map(Number);
    return hours * 60 + minutes;
  };

  formatDate(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  minutesToTimeString(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours > 12 ? hours - 12 : (hours === 0 ? 12 : hours);
    return `${displayHours}:${mins.toString().padStart(2, '0')}${period}`;
  }

  initTimeSelect() {
    if(!this.domElements.form['time']) {
      return;
    }

    this.timeSlimSelect = new SlimSelect({
      select: this.domElements.form['time'],
      settings: {
        showSearch: false,
      },
    });
  }

  setEmptyTimeOptions() {
    this.timeSlimSelect.setData([
      {
        value: '',
        text: '- - : - -'
      }
    ])
  }

  getLocationScheduleData(date) {
    const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'long' });
    const locationData = window.locationData?.[this.formState.location];
    
    if (!locationData) return null;
    
    return {
      daySchedule: locationData[this.formState.localDeliveryType + "_schedule"]?.[dayOfWeek],
      breakSchedule: locationData[this.formState.localDeliveryType + "_cutoff_time"]?.[dayOfWeek],
      cutoffTimes: locationData["cutoff_times"]?.[dayOfWeek],
      unavailableDays: locationData["unavailable_dates"] || [],
      dayOfWeek
    };
  }

  adjustWorkStartForToday(workStart, selectedDate) {
    // Get current time in EST timezone
    const todayEST = window.dayjs().tz('America/New_York');
    // Create Date object for comparison using format
    const today = this.dayjsToJsDate(todayEST);
    const todayFormatted = this.formatDate(today);
    const selectedDateFormatted = this.formatDate(selectedDate);
    
    if (selectedDateFormatted !== todayFormatted) {
      return workStart;
    }
    
    // Add one hour to current EST time
    const oneHourLaterEST = todayEST.add(1, 'hour');
    // Use EST hour and minute directly from dayjs
    const minutes = oneHourLaterEST.minute();
    let roundedMinutes, adjustedHours = oneHourLaterEST.hour();
    
    if (minutes === 0) {
      roundedMinutes = 0;
    } else if (minutes <= 30) {
      roundedMinutes = 30;
    } else {
      roundedMinutes = 0;
      adjustedHours += 1;
    }
    
    const minStartTime = `${adjustedHours}.${String(roundedMinutes).padStart(2, '0')}`;
    const workStartMinutes = this.timeToMinutes(workStart);
    const minStartMinutes = this.timeToMinutes(minStartTime);
    
    return minStartMinutes > workStartMinutes ? minStartTime : workStart;
  }

  isSlotDuringBreak(slotStart, slotEnd, breakStartMinutes, breakEndMinutes) {
    if (!breakStartMinutes || !breakEndMinutes) return false;
    
    return (slotStart >= breakStartMinutes && slotStart < breakEndMinutes) ||
           (slotEnd > breakStartMinutes && slotEnd <= breakEndMinutes) ||
           (slotStart < breakStartMinutes && slotEnd > breakEndMinutes);
  }

  generateTimeOptions() {
    if (this.selectorType !== "local") {
      return;
    }

    if (!this.formState.date || !this.formState.location) {
      this.setEmptyTimeOptions();
      this.timeSlimSelect?.disable();
      return;
    }

    this.timeSlimSelect?.enable();
    this.domElements.form['time'].innerHTML = '';
    
    const date = new Date(`${this.formState.date}`);
    const selectedDateFormatted = this.formatDate(date);
    const scheduleData = this.getLocationScheduleData(date);

    if (!scheduleData) {
      this.setEmptyTimeOptions();
      return;
    }
    
    const { daySchedule, breakSchedule, cutoffTimes, unavailableDays, dayOfWeek } = scheduleData;
    this.dayOfWeek = dayOfWeek;

    if (unavailableDays.includes(selectedDateFormatted)) {
      this.setEmptyTimeOptions();
      return;
    }
    
    if (!daySchedule) {
      this.setEmptyTimeOptions();
      return;
    }

    const scheduleArray = daySchedule.split('-');
    
    if (scheduleArray.length !== 2) {
      this.setEmptyTimeOptions();
      return;
    }
    
    let workStart = scheduleArray[0].trim();
    let workEnd = cutoffTimes || scheduleArray[1].trim();
    
    let breakStartMinutes = null;
    let breakEndMinutes = null;
    if (breakSchedule) {
      const breakArray = breakSchedule.split('-');
      if (breakArray.length === 2) {
        breakStartMinutes = this.timeToMinutes(breakArray[0].trim());
        breakEndMinutes = this.timeToMinutes(breakArray[1].trim());
      }
    }
    
    workStart = this.adjustWorkStartForToday(workStart, date);
    
    const workStartMinutes = this.timeToMinutes(workStart);
    const workEndMinutes = this.timeToMinutes(workEnd);
    let currentTime = workStartMinutes;
    const slotDuration = 60;

    const selectOptions = [{
      value: '',
      text: '- - : - -'
    }];
    
    while (currentTime + slotDuration <= workEndMinutes) {
      const slotStart = currentTime;
      const slotEnd = currentTime + slotDuration;
      
      if (this.isSlotDuringBreak(slotStart, slotEnd, breakStartMinutes, breakEndMinutes)) {
        currentTime = slotStart < breakEndMinutes ? breakEndMinutes : currentTime + slotDuration;
        continue;
      }
      
      const startTimeStr = this.minutesToTimeString(slotStart);
      const endTimeStr = this.minutesToTimeString(slotEnd);
      const displayText = `${startTimeStr} - ${endTimeStr}`;
      
      selectOptions.push({
        value: displayText,
        text: displayText,
        selected: this.formState.time === displayText,
        change: false
      });

      currentTime += slotDuration;
    }

    this.timeSlimSelect.setData(selectOptions);
  }

  setOutOfStock() {
    const parent = document.querySelector('.product-form-buttons');
    if(parent) {
      const addToCartButton = parent.querySelector('[name="add"]');
      const quantityInput = parent.querySelector('[name="quantity"]');
      const addToCartTextContent = parent.querySelector('.add-to-cart-text__content');

      if(addToCartButton) {
        addToCartButton.disabled = false;
      }
      if(addToCartTextContent) {
        addToCartTextContent.textContent = 'Add to Cart';
      }
      if(quantityInput) {
        const locationValue = this.domElements.form['location'] ? this.domElements.form['location'].value : 'nationwide';
        const isMerch = quantityInput.dataset?.merch === 'true';
        const isWorkshop = quantityInput.dataset?.workshop === 'true';
        const today = new Date().toLocaleDateString('en-GB', { 
          day: '2-digit',
          month: 'long', 
          year: 'numeric' 
        });
        const selectedDate = this.domElements.form['date']?.value || localStorage.getItem('delivery-date');
        const shouldCheckInventory = isWorkshop || isMerch || (selectedDate && today === selectedDate);
        
        if (shouldCheckInventory) {
          let inventoryValue = locationValue === 'nationwide' ? 'data-inventory-nationwide' : locationValue === 'georgetown'? 'data-inventory-georgetown' : 'data-inventory-bethesda';
          const inventory = quantityInput.getAttribute(`${inventoryValue}`);

          if(inventory && inventory === '0') {
            if(addToCartButton) {
              addToCartButton.disabled = true;
            }
            if(addToCartTextContent) {
              addToCartTextContent.textContent = 'Sold out';
            }
          }
        }
      }
    }
  }

  updateDozenNoteVisibility() {
    const dozenNoteElements = document.querySelectorAll('.product-card__details-dozen-note');
    if (!dozenNoteElements.length) return;

    const todayEST = window.dayjs().tz('America/New_York');
    const todayFormatted = todayEST.format('YYYY-MM-DD');
    const selectedDate = window.dayjs(this.formState.date);
    const selectedDateFormatted = selectedDate.format('YYYY-MM-DD');
    const isToday = selectedDateFormatted === todayFormatted;

    dozenNoteElements.forEach(element => {
      if (isToday) {
        element.classList.add('is-active');
      } else {
        element.classList.remove('is-active');
      }
    });
  }

  checkVariantsAvailability() {
    if(document.querySelector('[data-option-value-id]')){
      const locationValue = this.domElements.form['location'] ? this.domElements.form['location'].value : 'nationwide';
      const quantityInput = document.querySelector('.product-form-buttons [name="quantity"]');
      const isMerch = quantityInput?.dataset?.merch === 'true';
      const isWorkshop = quantityInput?.dataset?.workshop === 'true';
      const today = new Date().toLocaleDateString('en-GB', { 
        day: '2-digit',
        month: 'long', 
        year: 'numeric' 
      });
      const selectedDate = this.domElements.form['date']?.value || localStorage.getItem('delivery-date');
      const shouldCheckInventory = isWorkshop || isMerch || (selectedDate && today === selectedDate);
      
      if(shouldCheckInventory && (isWorkshop || (this.formState.location && this.formState.date))){
        let inventoryValue = locationValue === 'nationwide' ? 'data-option-nationwide' : locationValue === 'georgetown'? 'data-option-georgetown' : 'data-option-bethesda';
        const optionButtons = document.querySelectorAll('[data-option-value-id]');
        optionButtons.forEach(button => {
          if(button.getAttribute(inventoryValue) == '0') {
            button.setAttribute('data-option-available', false);
            button.closest('.variant-option__button-label').classList.add('variant-option__button-label--disabled');
          } else {
            button.setAttribute('data-option-available', true);
            button.closest('.variant-option__button-label').classList.remove('variant-option__button-label--disabled');
          }
        });
      }
    }
  }
}

if (!customElements.get('delivery-selector')) {
  customElements.define('delivery-selector', DeliverySelector);
}
